import React from "react";
import { Link } from "react-router-dom";
import "./Breadcrumbs.css";

export default function Breadcrumbs({ items }) {
  if (!items || items.length < 2) return null;
  return (
    <nav className="connct-breadcrumbs" aria-label="Breadcrumb">
      <ol>
        {items.map((item, index) => {
          const last = index === items.length - 1;
          return (
            <li key={`${item.path}-${item.name}`}>
              {last ? (
                <span aria-current="page">{item.name}</span>
              ) : (
                <Link to={item.path}>{item.name}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
